"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var buttonSizeStyle = function buttonSizeStyle(options) {
  var topBottomPadding = options.topBottomPadding,
      leftRightPadding = options.leftRightPadding,
      lineHeight = options.lineHeight,
      fontSize = options.fontSize;
  return hs_web_style_guide_1.css({
    fontSize: fontSize,
    padding: topBottomPadding + "px " + leftRightPadding + "px",
    lineHeight: lineHeight + "px"
  });
};

var buttonStyle = hs_web_style_guide_1.css({
  borderRadius: 4,
  border: 0,
  color: colors_1.white,
  backgroundColor: colors_1.jaffa,
  letterSpacing: 2.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textTransform: 'uppercase',
  ':hover': {
    backgroundColor: colors_1.tango
  },
  ':disabled': {
    color: colors_1.rgba(colors_1.white, 0.4)
  }
});

function TextButton(props) {
  var sm = props.sm,
      reg = props.reg,
      lg = props.lg,
      icon = props.icon,
      text = props.value,
      otherProps = __rest(props, ["sm", "reg", "lg", "icon", "value"]);

  var buttonSize = sm || reg ? 40 : 48;
  var lineHeight = sm ? 14 : 16;
  var options = {
    lineHeight: lineHeight,
    leftRightPadding: reg || lg ? 24 : 16,
    topBottomPadding: (buttonSize - lineHeight) / 2,
    fontSize: sm ? 12 : 14
  };
  var buttonClassName = otherProps.className ? "textButton " + otherProps.className : 'textButton';
  return React.createElement("button", __assign({
    className: buttonClassName,
    type: "text"
  }, buttonSizeStyle(options), buttonStyle, font_1.bold, otherProps), icon, icon && React.createElement("span", null, "\xA0"), text);
}

exports.TextButton = TextButton;